import $ from 'jquery';

window.$ = window.jQuery = $;
window.$ = window.jQuery = $.noConflict();


export class ValueCapacitor {
    constructor() {

        $('body').on('change', '.js-hidden-valuer-trigger', function (event) {
            let element = $(this);

            let hidden = $(`.js-hidden-valuer[data-target="${element.attr('name')}"]`);
            if (hidden) {
                hidden.prop('checked', true)
                hidden.parent().find('.custom-label').addClass('active');
                console.log('asdxxx');
            }

            console.log('js-hidden-valuer-trigger');
            console.log(hidden);
            console.log(element);
            console.log(element.parent());
            console.log(element.parent().hasClass('isActive'));
            if (element.parent().hasClass('isActive')) {
                element.parent().removeClass('isActive');
                console.log('asdccc');
            }

        });
    }
}